import React, { useEffect, useState } from 'react';
import api from '../services/api';
import CoverflowCarousel from './CoverflowCarousel';

/* =========================================================
   CoverflowSlideshow — substitui o antigo Slideshow (crossfade)
   pelo carrossel 3D estilo cover flow, alimentado pelas mesmas
   imagens institucionais de /api/slideshow/images.
   ========================================================= */
export default function CoverflowSlideshow() {
    const [images, setImages] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const ctrl = new AbortController();
        (async () => {
            try {
                const { data } = await api.get('/api/slideshow/images', { signal: ctrl.signal });
                setImages(Array.isArray(data) ? data : []);
            } catch (e) {
                if (!ctrl.signal.aborted) console.error('Slideshow:', e);
            } finally {
                if (!ctrl.signal.aborted) setLoaded(true);
            }
        })();
        return () => ctrl.abort();
    }, []);

    if (loaded && images.length === 0) {
        return <div className="slideshow-container-placeholder">Nenhuma imagem para exibir.</div>;
    }
    if (!loaded) {
        return <div className="slideshow-container-placeholder skeleton-line" style={{ border: 'none' }} />;
    }

    const coverflowImages = images.map((img, i) => ({
        srcUrl: img.image_url,
        alt: `Slide ${i + 1}`,
    }));

    return (
        <div className="slideshow-container slideshow-container--coverflow">
            <CoverflowCarousel
                images={coverflowImages}
                activeWidth={420}
                activeHeight={300}
                restWidth={120}
                restHeight={170}
                gap={18}
                radius={10}
                showArrows={coverflowImages.length > 1}
                arrowColor="#101C5D"
                arrowBackground="#ffffff"
                arrowSize={40}
                arrowPosition={92}
                autoplay={coverflowImages.length > 1}
                autoplayDirection="rightToLeft"
                transition={{ duration: 0.6, delay: 4 }}
            />
        </div>
    );
}